import {Text as NativeText, TextStyle} from 'react-native';
import {TextProps} from './Text.props';
import {Typography} from '../../Styles';
import {useAccessibility, useTheme} from '../../Hooks';

const Text: React.FC<TextProps> = (props) => {
  const {
    children,
    color = 'text',
    weight = 'regular',
    align = 'auto',
    fontSize = 14,
    lineHeight,
    allowFontScaling = true,
    maxFontSizeMultiplier = 1.8,
    style,
    ...restProps
  } = props;

  const theme = useTheme();
  const {textScale} = useAccessibility();

  const textStyles: TextStyle = {
    fontSize: Math.round(fontSize * textScale),
    lineHeight: lineHeight ? Math.round(lineHeight * textScale) : undefined,
    color: theme.colors[color],
    textAlign: align,

    ...Typography[weight],
  };

  return (
    <NativeText
      allowFontScaling={allowFontScaling}
      maxFontSizeMultiplier={maxFontSizeMultiplier}
      {...restProps}
      style={[textStyles, style]}
    >
      {children}
    </NativeText>
  );
};

export default Text;
